import React from 'react'
import { Oval } from "react-loader-spinner";

const Loader = ({color = '#7539ff'}) => {
    return (
        <>
            <Oval
                height={60}
                width={60}
                color={color}
                wrapperStyle={{ justifyContent: "center" }}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor={color}
                strokeWidth={2}
                strokeWidthSecondary={2}
            />
        </>
    )
}

export default Loader